module.exports = __webpack_public_path__ + "img/sertificate.0b33ebaf.svg";